// Full export from Supagas https://jira.at.convert.digital/browse/SUP0003-603
// Commented out the options that are not requested for.
export const DEHIRE_REASON_OPTIONS = [
  { label: 'Commercial - Business ceased trading', value: '50' },
  // { label: 'Too Many Empties, still using same product', value: '51' },
  { label: 'Short term hire / Temp location /Couriers', value: '52' },
  // { label: 'Commercial - Month end stock reduction', value: '53' },
  // { label: 'Discontinued Product Application', value: '54' },
  // { label: 'Change in Product Size - Different cylinder size new hire', value: '55' },
  // { label: 'Empties not collected on previous delivery', value: '56' },
  { label: 'Gone to Competitor - Pricing', value: '57' },
  { label: 'Gone to Competitor - Service', value: '58' },
  // { label: 'Non-Disclosure of Reason - Investigation Required', value: '59' },
  { label: 'Electric / Diesel forklift no longer LPG', value: '60' },
  // { label: 'Domestic - Switched to natural gas', value: '61' },
  { label: 'Domestic - Moved out', value: '62' },
  { label: 'Domestic LPG - End of Winter', value: '63' },
  { label: 'Domestic - Reducing stock to save on rent', value: '64' },
  // { label: 'Cylinder utilisation forklift cylinders', value: '65' },
  // { label: 'Administration / Accounts / Non payment', value: '66' },
  // { label: 'Delivery location change - new hire other location', value: '67' },
  // { label: 'Heatagas/Heater Dehire (End of Winter)', value: '68' },
  // { label: 'Non-Compliant Site', value: '69' },
  // { label: 'Incorrect Order Placed', value: '70' },
  // { label: 'Cylinder for testing', value: '71' },
  // { label: 'Trial cylinders', value: '72' },
  // { label: 'Customer owned cylinders to be refilled', value: '73' },
  // { label: 'Agent customer dehire', value: '74' },
  // { label: 'Deceased customer', value: '75' },
  // { label: 'Domestic Dehire - Collected by Competitor', value: '76' },
  // { label: 'Natural Event Damage Collection', value: '77' },
  // { label: 'Non-Compliant Vehicle', value: '78' },
  // { label: 'COVID-19', value: '79' },
  // { label: 'Defence Housing Australia', value: '80' },
  { label: 'Renovations', value: '81' },
  // { label: 'Requested Kit Change', value: '82' },
  // { label: 'Transfer of Funding', value: '83' },
  // { label: 'No Longer Required / Funding Ceased', value: '84' },
  // { label: 'Cylinder(s) found/picked up by competitor', value: '85' },
  // { label: 'Switched to electricity/solar', value: '86' },
  // { label: 'LPG 45kg Promo', value: 'P1' },
]

export const IMAGE_SIZE = '56px'

export const CART_DEBOUNCE_TIME = 300

export enum CART_LINE_PURCHASE_TYPE {
  RENTAL = 'Rent',
  REFILL = 'Refill',
}

export enum CART_LINE_PRICING_STATUS {
  STOCKHOLDING = 'STOCKHOLDING',
  HAS_HISTORICAL_ORDER = 'HAS_HISTORICAL_ORDER',
  NEW_ORDER = 'NEW_ORDER',
}
